// extracted by mini-css-extract-plugin
module.exports = {"Notification_fail":"useToast_Notification_fail__1Y7Jk","Notification_warn":"useToast_Notification_warn__2U7KE"};